// extracted by mini-css-extract-plugin
export var cardHeader = "_f1-0";
export var reorderHandle = "_f1-3";
export var titleArea = "_f1-1";
export var titleAreaWithHandle = "_f1-2";